// Wizard step constants used across multiple components
export const WIZARD_STEPS: string[] = [
  "Identificare",
  "Servicii NIS 2",
  "Dimensiune",
  "Esențiale",
  "Importante",
  "Rezultate",
  "Generare Raport",
];

// Main steps for the wizard navigation (simplified view)
export const MAIN_WIZARD_STEPS: string[] = [
  "Identificare",
  "Dimensiune",
  "Identificarea serviciilor NIS2",
  "Clasificare NIS2",
  "Generare Raport",
];

// Maturity evaluation top-navigation steps
export const MATURITY_STEPS: string[] = [
  "Evaluare preliminară",
  "Sumar preliminar",
  "Evaluare asistată",
  "Sumar evaluare",
];

// Risk analysis wizard top-navigation steps
export const RISK_WIZARD_STEPS: string[] = [
  "Sectoare",
  "Analiza de risc",
  "Rezultat analiza",
  "Generare raport",
];

export const RISK_WIZARD_STEP_SUBLABELS: readonly (string | undefined)[] = [
  undefined,
  "validare si modificare",
  undefined,
  undefined,
];

// Step order for service mapping component (different order)
export const SERVICE_MAPPING_STEPS: string[] = [
  "Identificare",
  "Dimensiune",
  "Servicii NIS 2",
  "Esențiale",
  "Importante",
  "Rezultate",
  "Generare Raport",
];

export type WizardStep = string;
export type MainWizardStep = string;
export type ServiceMappingStep = string;
